import { useNavigate, Link } from "react-router-dom";
import { useState } from "react";

const API_BASE = process.env.REACT_APP_USER_SERVICE_URL;

export default function SellerLogin() {
  const navigate = useNavigate();

  const [showPassword, setShowPassword] = useState(false);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [error, setError] = useState("");

  const isFormValid = email.trim() !== "" && password.trim() !== "";

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!isFormValid || isSubmitting) return;
    setError("");

    try {
      setIsSubmitting(true);
      const response = await fetch(`${API_BASE}/sellers/auth/login`, {
        method: "POST",

        headers: { "Content-type": "application/json" },
        body: JSON.stringify({ email, password }),
      });
      if (!response.ok) {
        const data = await response.json().catch(() => ({}));
        throw new Error(data.message || "Invalid email or password");
      }

      navigate("/mfa", {
        replace: true,
        state: { email }, // pass email securely in memory
      });
    } catch (err) {
      setError(err.message || "Login faild");
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="container-fluid min-vh-100">
      <div className="row min-vh-100">
        {/* Brand panel */}
        <div
          className="col-md-5 d-none d-md-flex align-items-center justify-content-center text-white"
          style={{ backgroundColor: "#041e42" }}
        >
          <h2 className="fw-semibold">Afrogebeya</h2>
        </div>

        {/* Auth panel */}
        <div className="col-12 col-md-7 d-flex flex-column">
          <div className="p-3 d-md-none fw-semibold">
            Afrogebeya Seller Center
          </div>

          <div className="flex-grow-1 d-flex align-items-center justify-content-center px-3">
            <div className="card shadow-sm w-100" style={{ maxWidth: 420 }}>
              <div className="card-body p-4">
                <h3 className="fw-semibold text-center mb-4">Welcome!</h3>
                {/* Error message */}{" "}
                {error && (
                  <div className="alert alert-danger text-center" role="alert">
                    {" "}
                    {error}{" "}
                  </div>
                )}
                <form onSubmit={handleSubmit}>
                  <div className="mb-3">
                    <label className="form-label">Email</label>
                    <input
                      type="email"
                      className="form-control form-control-lg"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      disabled={isSubmitting}
                      required
                    />
                  </div>

                  <div className="mb-4 position-relative">
                    <label className="form-label">Password</label>
                    <input
                      type={showPassword ? "text" : "password"}
                      className="form-control form-control-lg"
                      value={password}
                      onChange={(e) => setPassword(e.target.value)}
                      disabled={isSubmitting}
                      required
                    />
                    <i
                      className={`bi ${
                        showPassword ? "bi-eye-slash" : "bi-eye"
                      } position-absolute`}
                      style={{
                        right: 14,
                        top: 46,
                        cursor: isSubmitting ? "not-allowed" : "pointer",
                        opacity: isSubmitting ? 0.5 : 1,
                      }}
                      onClick={() =>
                        !isSubmitting && setShowPassword(!showPassword)
                      }
                    />
                  </div>

                  <button
                    type="submit"
                    disabled={!isFormValid || isSubmitting}
                    className={`w-100 py-2 fw-semibold btn ${
                      isFormValid && !isSubmitting
                        ? "btn-primary"
                        : "btn-secondary"
                    }`}
                  >
                    {isSubmitting ? (
                      <>
                        <span
                          className="spinner-border spinner-border-sm me-2"
                          role="status"
                          aria-hidden="true"
                        />
                        Signing in…
                      </>
                    ) : (
                      "LOG IN"
                    )}
                  </button>
                </form>
                <div className="text-center mt-4">
                  <Link
                    to={isSubmitting ? "#" : "/reset-password"} // prevent navigation if submitting
                    onClick={(e) => {
                      if (isSubmitting) e.preventDefault();
                    }}
                    className={`text-decoration-none ${
                      isSubmitting ? "text-muted" : ""
                    }`}
                    style={{ pointerEvents: isSubmitting ? "none" : "auto" }}
                  >
                    Forgot your <strong>Password?</strong>
                  </Link>
                </div>
                <div className="text-center mt-4">
                  <Link
                    to={isSubmitting ? "#" : "/register"} // prevent navigation if submitting
                    onClick={(e) => {
                      if (isSubmitting) e.preventDefault();
                    }}
                    className={`text-decoration-none ${
                      isSubmitting ? "text-muted" : ""
                    }`}
                    style={{ pointerEvents: isSubmitting ? "none" : "auto" }}
                  >
                    Create account <strong>Register</strong>?
                  </Link>
                </div>
              </div>
            </div>
          </div>

          <div className="text-center pb-3 small px-3">
            <Link to="/terms">Terms and Conditions</Link> |
            <Link to="/contact-support">Contact Support</Link>
          </div>
        </div>
      </div>
    </div>
  );
}
